import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
// import TCLLogo from '../../img/tcl_logo.png';
import './SurveyCard.css';

// const BusinessSuggestionCard = () => {
//     const { user } = useSelector((state) => state.authReducer.authData);
//     const [form, setForm] = useState({ businessName: '', phoneNumber: '', email: '', contactPerson: '' });
//     const [submitted, setSubmitted] = useState(false);
//     const [dismissed, setDismissed] = useState(false);

//     const TCL_ID = process.env.REACT_APP_TCL_GROUP_ID;
//     const followsTCL = user.follow?.includes(TCL_ID);
//     if (!followsTCL || dismissed) return null;

//     const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!form.businessName.trim()) return;
//         try {
//             await fetch(`${process.env.REACT_APP_API_BASE_URL}/survey/business`, {
//                 method: 'POST',
//                 credentials: 'include',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ ...form, userId: user._id, surveyId: 'business_suggestion' })
//             });
//             setSubmitted(true);
//         } catch (error) {
//             console.error('Business suggestion error:', error);
//         }
//     };

//     return (
//         <div className="survey-card business-suggestion-card">
//             <button className="survey-dismiss" onClick={() => setDismissed(true)}>✕</button>
//             <div className="business-card-header">
//                 <div style={{
//                     width: 32,
//                     height: 32,
//                     borderRadius: 6,
//                     background: '#f97316',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     fontSize: 10,
//                     fontWeight: 700,
//                     color: 'white',
//                     flexShrink: 0,
//                     letterSpacing: 0.5
//                 }}>
//                     TCL
//                 </div>
//                 {/* <img src={TCLLogo} alt="TCL" className="tcl-logo" /> */}
//                 <span>Know a local business that should be on TCL?</span>
//             </div>
//             {!submitted ? (
//                 <form onSubmit={handleSubmit}>
//                     <input name="businessName" placeholder="Business Name *" required onChange={handleChange} className="survey-input" />
//                     <input name="phoneNumber" placeholder="Phone Number (optional)" onChange={handleChange} className="survey-input" />
//                     <input name="email" placeholder="Email (optional)" onChange={handleChange} className="survey-input" />
//                     <input name="contactPerson" placeholder="Contact Person (optional)" onChange={handleChange} className="survey-input" />
//                     <button type="submit" className="survey-submit button">Submit</button>
//                 </form>
//             ) : (
//                 <div className="survey-thankyou">
//                     Thank you for your suggestion! We'll look into it.
//                     <button className="survey-submit button" onClick={() => setDismissed(true)}>Close</button>
//                 </div>
//             )}
//         </div>
//     );
// };

const BusinessSuggestionCard = () => {
    const { user } = useSelector((state) => state.authReducer.authData);
    const [form, setForm] = useState({ businessName: '', phoneNumber: '', email: '', contactPerson: '' });
    const [submitted, setSubmitted] = useState(false);
    const [dismissed, setDismissed] = useState(false);
    const resetTimerRef = useRef(null);

    const TCL_ID = process.env.REACT_APP_TCL_GROUP_ID;
    const followsTCL = user.follow?.includes(TCL_ID);
    useEffect(() => {
        return () => {
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
        };
    }, []);

    if (!followsTCL || dismissed) return null;

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const resetForm = () => {
        setSubmitted(false);
        setForm({ businessName: '', phoneNumber: '', email: '', contactPerson: '' });
        if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.businessName.trim()) return;
        try {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/survey/business`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userId: user._id,
                    businessName: form.businessName,
                    phoneNumber: form.phoneNumber,
                    email: form.email,
                    contactPerson: form.contactPerson
                })
            });
            setSubmitted(true);

            resetTimerRef.current = setTimeout(() => {
                resetForm();
            }, 20000);

        } catch (error) {
            console.error('Business suggestion error:', error);
        }
    };

    return (
        <div className="survey-card business-suggestion-card">
            {/* <button className="survey-dismiss" onClick={() => setDismissed(true)}>✕</button> */}
            <div className="business-card-header">
                <div style={{
                    width: 32, height: 32, borderRadius: 6, background: '#f97316',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 10, fontWeight: 700, color: 'white', flexShrink: 0, letterSpacing: 0.5
                }}>
                    TCL
                </div>
                <span>Know a local business that should be on TCL?</span>
            </div>
            {!submitted ? (
                <form onSubmit={handleSubmit}>
                    <input name="businessName" placeholder="Business Name *" required value={form.businessName} onChange={handleChange} className="survey-input" />
                    <input name="phoneNumber" placeholder="Phone Number (optional)" value={form.phoneNumber} onChange={handleChange} className="survey-input" />
                    <input name="email" placeholder="Email (optional)" value={form.email} onChange={handleChange} className="survey-input" />
                    <input name="contactPerson" placeholder="Contact Person (optional)" value={form.contactPerson} onChange={handleChange} className="survey-input" />
                    <button type="submit" className="survey-submit button">Submit</button>
                </form>
            ) : (
                <div className="survey-thankyou">
                    <div>Thank you for your suggestion! We'll look into it.</div>
                    <div style={{ fontSize: 11, color: '#9ca3af', margin: '6px 0' }}>
                        Form resets in 20 seconds...
                    </div>
                    <button className="survey-submit button" onClick={resetForm}>
                        Submit Another
                    </button>
                </div>
            )}
        </div>
    );
};

export default BusinessSuggestionCard;